/**
 * Unions API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { LoyaltyCollectionSectionDto } from './loyaltyCollectionSectionDto';


export interface AddLoyaltyCollectionRequestDto { 
    title: string;
    /** @deprecated */
    contentText?: string;
    validTill?: string;
    status: number;
    sortOrder: number;
    pushTitle?: string;
    pushText?: string;
    pushSendOn?: string;
    bannerBackgroundPhotoId?: string;
    bannerTitle?: string;
    /**
     * Список продуктов в коллекции
     * @deprecated
     */
    products?: Array<string>;
    /**
     * Список секций в коллекции
     */
    sections?: Array<LoyaltyCollectionSectionDto>;
}

